import {CellSpanInfo} from '../types';

export const getGroupedCellSpanInfos = <TCellSpanData = any>(
  cellSpanInfos: Array<CellSpanInfo<TCellSpanData>>,
) => {
  const retVal: CellSpanInfo<TCellSpanData>[][] = [];
  let currentList: CellSpanInfo<TCellSpanData>[] = [];
  retVal.push(currentList);

  for (let i = 0; i < cellSpanInfos.length; i++) {
    const currentInfo = cellSpanInfos[i];
    if (currentList.length > 0) {
      // Check if current starts after prev's end
      if (
        currentInfo.start <
        currentList[currentList.length - 1].start +
          currentList[currentList.length - 1].length
      ) {
        // Start new line
        currentList = [currentInfo];
        retVal.push(currentList);
      } else {
        // Push next to current line
        currentList.push(currentInfo);
      }
    } else {
      // Just push, current list is empty
      currentList.push(currentInfo);
    }
  }
  return retVal;
};
